import {
  Directive,
  ViewContainerRef,
  Input,
  ComponentFactoryResolver,
  Component,
  ComponentFactory,
  Compiler,
  NgModule, ReflectiveInjector
} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {Constants} from "../services/constants";
import {Router, NavigationEnd} from "@angular/router";
import {UserService} from "../services/user.service";


export interface IHaveDynamicData {
  entity: any;
}

@Directive({
  selector: 'dynamic-html-outlet',
})
export class DynamicHTMLOutlet {
  @Input() src: string;

  constructor(private vcRef: ViewContainerRef,
              protected compiler: Compiler,
              private resolver: ComponentFactoryResolver) {
  }

  ngOnChanges() {
    if (!this.src) return;

    //noinspection TypeScriptUnresolvedFunction
    this.createComponentFactory(this.src)
      .then(factory => {
        const injector = ReflectiveInjector.fromResolvedProviders([], this.vcRef.parentInjector);
        this.vcRef.createComponent(factory, 0, injector, []);
      });
  }


  // this object is singleton - so we can use this as a cache
  private _cacheOfFactories: {[templateKey: string]: ComponentFactory<IHaveDynamicData>} = {};

  //noinspection TypeScriptUnresolvedVariable
  public createComponentFactory(template: string): Promise<ComponentFactory<IHaveDynamicData>> {

    let factory = this._cacheOfFactories[template];

    if (factory) {
      console.log("Module and Type are returned from cache")

      //noinspection TypeScriptUnresolvedFunction
      return new Promise((resolve) => {
        resolve(factory);
      });
    }

    // unknown template ... let's create a Type for it
    let type = this.createNewComponent(template);
    let module = this.createComponentModule(type);

    //noinspection TypeScriptUnresolvedFunction
    return new Promise((resolve) => {
      this.compiler
        .compileModuleAndAllComponentsAsync(module)
        .then((moduleWithFactories) => {
          factory = moduleWithFactories.componentFactories.filter(item => item.componentType == type)[0];

          this._cacheOfFactories[template] = factory;

          resolve(factory);
        });
    });
  }

  protected createNewComponent(tmpl: string) {
    @Component({
      selector: 'dynamic-component',
      template: tmpl,
    })
    class CustomDynamicComponent implements IHaveDynamicData {
      @Input() public entity: any;
      private tenantBucket = Constants.TENANT_BUCKET();
      private router: Router = Constants.router;
      private isHomePage: boolean = false;
      private isHeaderHidden: boolean = false;
      buyerLogin = false;

      constructor(private userService: UserService) {
        this.setIsHomePage();
        this.checkLogin();
      }
        checkLogin() {
        if (this.userService.isLoggedIn()) {
          this.buyerLogin = true;
        } else {
          this.buyerLogin = false;
        }
      }

      private setIsHomePage() {
        if(this.router.url == "/home") {
          this.isHomePage = true;
        }
        this.router.events.subscribe((event: any) => {
          if(event instanceof NavigationEnd) {
            window.scrollTo(0, 0);
            if(event.url == "/home") {
              this.isHomePage = true;
            } else {
              this.isHomePage = false;
              this.isHeaderHidden = false;
            }
          }
        });
      }
    }

    // a component for this particular template
    return CustomDynamicComponent;
  }

  protected createComponentModule(componentType: any) {
    @NgModule({
      imports: [
        SharedModule
      ],
      declarations: [
        componentType
      ],
    })
    class RuntimeComponentModule {
    }
    // a module for just this Type
    return RuntimeComponentModule;
  }

}



// WEBPACK FOOTER //
// ./src/app/directives/dynamic-html-outlet.directive.ts